<suite-rfb-collapse [title]="titulo">
    <loading-animation *ngIf="!socios && !initError"></loading-animation>
    <fieldset *ngIf="socios">
        <div class="row">
            <via-socio-admin-qsa-table [cnpj]="cnpj" [razaoSocial]="razaoSocial" [socios]="socios"></via-socio-admin-qsa-table>
        </div>
    </fieldset>
</suite-rfb-collapse>